import React from "react";
// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import OportunityIcon from "@material-ui/icons/WbIncandescent";
import Contacts from "@material-ui/icons/Contacts";
import Notes from "@material-ui/icons/Subject";
import Participants from "@material-ui/icons/Group";
import Docs from "@material-ui/icons/Description";
import Chat from "@material-ui/icons/Chat";
import Build from "@material-ui/icons/Build";
import Tasks from "@material-ui/icons/PlaylistAddCheck";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import PropertyData from './PropertyData.jsx'
import PropertyTrack from './PropertyTrack.jsx'
import PropertyImages from './PropertyImages.jsx'
import ContactsTab from './ContactsTab.jsx'
import ParticipantsTab from './ParticipantsTab.jsx'
import ClientsTab from './ClientsTab.jsx'
import NotesTab from './NotesTab.jsx'
import TasksTab from './TasksTab.jsx'

const styles = {
  textCenter: {
    textAlign: "center"
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  }
};

class PropertyTabs extends React.Component{
  render(){
    const { classes } = this.props;
    const { property } = this.props;
    return (
      <div>
        <CustomTabs
          plainTabs
          headerColor="info"
          tabs={[
            {
              tabName: "Oportunity",
              tabIcon: OportunityIcon,
              tabContent: (
                    <PropertyData oportunity={property} />
              )
            },
            {
              tabName: "Docs",
              tabIcon: Docs,
              tabContent: (
                    <PropertyImages oportunity={property} />
              )
            },
            {
              tabName: "Tasks",
              tabIcon: Tasks,
              tabContent: (
                    <TasksTab oportunity={property} />
              )
            },
            {
              tabName: "Notes",
              tabIcon: Notes,
              tabContent: (
                    <NotesTab oportunity={property} />
              )
            },
            {
              tabName: "Contacts",
              tabIcon: Contacts,
              tabContent: (
                    <ContactsTab oportunity={property} />
              )
            },
            {
              tabName: "Clients",
              tabIcon: BusinessCenter,
              tabContent: (
                    <ClientsTab oportunity={property} />
              )
            },
            {
              tabName: "Participants",
              tabIcon: Participants,
              tabContent: (
                    <ParticipantsTab oportunity={property} />
              )
            }
          ]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(PropertyTabs);
